import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beaafd86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actions-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--large" }, "Logga in", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content__top" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--large" }, "Admin", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Snapshot")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Analytics")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Request Logs")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_tabs = _resolveComponent("base-tabs")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_openBlock(), _createBlock(_component_main_container_shell, { "hide-header": true }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (!_ctx.isAdmin)
          ? (_openBlock(), _createBlock(_component_base_card, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_base_input, {
                    id: "username",
                    label: "Användarnamn",
                    type: "text",
                    modelValue: _ctx.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                    placeholder: "Username"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_base_input, {
                    id: "password",
                    label: "Lösenord",
                    type: "password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    placeholder: "Password"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_base_button, {
                    onClick: _ctx.authenticateAdmin,
                    text: "Login"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_base_button, {
                    theme: "ghost",
                    onClick: _ctx.logout,
                    text: "Log out"
                  }, null, 8, ["onClick"])
                ]),
                _createVNode(_component_base_tabs, null, {
                  tabs: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { name: 'SnapshotList' } }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, { to: { name: 'Analytics' } }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, { to: { name: 'RequestLogs' } }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ]),
    _: 1
  }))
}